import { ComponentsModule } from './../../components/components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './../../material.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RealTimeRoutingModule } from './real-time-routing.module';
import { RealTimeComponent } from './real-time.component';
import { EmergenciesListComponent } from './emergencies-list/emergencies-list.component';
import { AgmCoreModule } from '@agm/core';
import { ChartsModule as ng2ChartsModule } from 'ng2-charts';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [RealTimeComponent, EmergenciesListComponent],
	imports: [
		CommonModule,
		RealTimeRoutingModule,
		MaterialModule,
		ReactiveFormsModule,
		TranslateModule,
		ComponentsModule,
		ng2ChartsModule,
		FormsModule,
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyDVO2M65l7mXKNWwbAoW64HJk2c7o1kQl8',
		}),
	],
})
export class RealTimeModule {}
